import React from 'react'
import { Alert, Textarea, Button } from 'stylist'
import styled from '@emotion/styled'

const ErrorContainer = styled.div`
  flex: 1;

  & textarea {
    width: 100%;
  }
`

const ErrorBox = ({ error, retry }) => {
  console.error(error)
  console.log(JSON.stringify(error))
  let detailText = error.toString()
  if (error && error.response) {
    detailText += `\nResponse ${error.response.status} (${
      error.response.statusText
    })`
  }

  return (
    <ErrorContainer>
      <Alert kind="error" message="Oh no! Something went wrong." />
      <Textarea width="100%" disabled rows="10" value={detailText} />
      {retry && <Button kind="primary" onClick={retry} />}
    </ErrorContainer>
  )
}

export default ErrorBox



// WEBPACK FOOTER //
// ./src/routes/admin/ErrorBox.js